import React, { useMemo, useState } from 'react';

import type { ITALodgingReq } from 'components/common/PlanYourTrip/types';
import type { IAccommodationPage } from 'api/tripadvisor/types';
import { accommodationSortingBySortType, sortAccommodationsByPrice } from 'util/accommodationsSortings';
import { SortByAccommodations, SortByAccommodationsDefault } from 'components/common/SortAccomodations/constants';

import { useOffers } from 'api/resort/useOffers';
import { useOTSTranslation } from 'i18n/useOTSTranslation';

import { ErrorBlock } from 'components/common/ErrorBlock';
import { SortAccommodations } from 'components/common/SortAccomodations';
import { Accommodation } from 'components/resort/Accomodation';

import styles from './styles.module.scss';

interface IProps {
  preAccommodations?: IAccommodationPage | null,
  /**
   * Trip Adviser params to load accommodation
   */
  searchParams: ITALodgingReq,
  areAccommodationsFresh: boolean,
}
const AccommodationsList = ({
  preAccommodations = { data: [] },
  searchParams,
  areAccommodationsFresh,
}: IProps) => {
  const { t } = useOTSTranslation('common');
  const [sortBy, setSortBy] = useState<SortByAccommodations>(SortByAccommodationsDefault);

  const locationList = useMemo(
    () => (preAccommodations?.data ?? []).map((a) => a.location_id).sort(),
    [preAccommodations],
  );
  const { offerMap, areOffersLoading, error } = useOffers(
    locationList,
    searchParams.checkIn,
    searchParams.checkOut,
    searchParams.numAdults,
    searchParams.numAdults,
  );

  const sorted = useMemo(() => {
    if (accommodationSortingBySortType[sortBy]) {
      return sortAccommodationsByPrice(preAccommodations?.data ?? [], offerMap, sortBy);
    }
    return (preAccommodations?.data ?? []);
  }, [(preAccommodations?.data ?? []), sortBy, offerMap]);

  return (
    <>
      {error && <ErrorBlock className={styles.error}>{error}</ErrorBlock>}
      <SortAccommodations
        setSortBy={setSortBy}
        sortBy={sortBy}
        className={styles.header}
      />
      {areAccommodationsFresh && locationList.length === 0 && (
        <h2 className="m-4 p-4" style={{ textAlign: 'center' }}>
          <span>{t('resort.lodging.noResults')}</span>
        </h2>
      )}
      <div className={styles.offerList}>
        {sorted.map((acc) => (
          <Accommodation
            className={styles.accommodationWrapper}
            key={acc.location_id}
            accommodation={acc}
            isFresh={areAccommodationsFresh}
            offers={offerMap[acc.location_id]}
            areOffersLoading={areOffersLoading}
          />
        ))}
      </div>
    </>
  );
};

export default AccommodationsList;
